import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";

const data = [
  { name: "Speaking", value: 400 },
  { name: "Writing", value: 300 },
  { name: "Reading", value: 300 },
  { name: "Listening", value: 200 },
];

const COLORS = ["#86efac", "#93c5fd", "#fdba74", "#c084fc"];

const PieCharts = () => {
  return (
    <div className="h-full min-h-[220px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart margin={{ top: 12, right: 12, bottom: 12, left: 12 }}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="58%"
            outerRadius="78%"
            paddingAngle={5}
            dataKey="value"
            stroke="#f8fafc"
            strokeWidth={4}
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieCharts;
